export const applyMinMaxFilter = (
  value: number | undefined,
  min?: number,
  max?: number
) => {
  if (min === undefined && max === undefined) return true;
  if (value === undefined) return false;
  if (min !== undefined && Math.abs(value) < min) return false;
  if (max !== undefined && Math.abs(value) > max) return false;
  return true;
};
